<template>
  <Layout>
    <div class="platform">
      <div class="backimg">
        <div class="backimgBox">
          <StaticBanner :banner-date="bannerDate"></StaticBanner>
        </div>
      </div>
      <div class="title container" id="title">
        <div class="tab-block pt-lyd-120 container">
          <div class="fs-1 fw-bold text-center lyd-title-colo1" data-aos="fade-up">平台概述</div>
          <div class='fs-3 text-center lyd-title-colo1 title_div' data-aos="fade-up">博信诚
            智慧创新平台ECOP是基于云架构、微服务、低代码理念建设的轻量级开发支撑平台，业务及行业细分服务由多个细分组件组成，各种产品都能独立使用，企业可选择任一/多个组件实现行业管理组件化。</div>
          <img src="@/assets/images/platform/platformone.png" alt="">
        </div>
      </div>
      <div class="ability">
        <div class="abilityBoxs">
          <div class="abilityBox">
            <img class="abilityBox_img" src="@/assets/images/platform/bigData.png" alt="" />
            <div class="abilityBox_content" data-aos="fade-up">
              <h4 class="fs-1 text-white">大数据、微服务支持能力</h4>
              <div class="fs-text text-white">灵活的进行各种资源部署,将分布在各处的资源综合利用，负载由单个节点转移到多个，从而提高效率，分布式可以避免由于单个节点失效而使整个系统崩溃的危险</div>
            </div>
          </div>
          <div class="abilityBox">
            <img class="abilityBox_img" src="@/assets/images/platform/modeling.png" alt="">
            <div class="abilityBox_content" data-aos="fade-up">
              <h4 class="fs-1 text-white">低代码建模能力</h4>
              <div class="fs-text text-white">
                通过不同需求进行业务场景、财务建模，搭建业务底层结构框架，实现数据多视角填报、计算、展现和分析且支持动态多维汇总，动态成员公式和灵活的计算逻辑个性化展示，即时呈现，即时更新，更是做到了0代码鼠标拖带式操作交互。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="framework container">
        <div class="tab-block pt-lyd-120 container ind">
          <div class="fs-1 fw-bold text-center lyd-title-colo1">平台架构图</div>
          <p class="fs-3 text-center lyd-title-colo1">云架构、低代码、微服务</p>
        </div>
        <div class="framework_btns container" v-if="windowWidth > 767">
          <div class="framework_btn" :class="types == 1 ? 'active' : ''" @click="change(1)">技术中台</div>
          <div class="framework_btn" :class="types == 2 ? 'active' : ''" @click="change(2)">业务中台</div>
          <div class="framework_btn" :class="types == 3 ? 'active' : ''" @click="change(3)">数据中台</div>
          <div class="framework_btn" :class="types == 4 ? 'active' : ''" @click="change(4)">连接中台(连接器)</div>
        </div>
        <div class="framework_contents container" v-if="windowWidth > 767">
          <div class="framework_content" v-if="(types-1) == index" v-for="(item,index) in frameworkData" :key="index">
            <p class="fs-3 text-center lyd-title-colo1 framework_content_title" data-aos="fade-up">{{ item.test }}</p>
            <img :src="item.img" alt="">
          </div>
        </div>
        <div class="valuer" v-else>
          <div class="valueBoxes">
            <swiper class="mySwipe" style="margin-bottom: 1rem;" :options="swiperOptiones" ref="videoSwiper">
              <swiper-slide>
                <div class="fs-1 text-center" style="color: #005BAB;">技术中台</div>
                <div class="framework_content">
                  <img src="@/assets/images/platform/technologybgcopy.png" alt="">
                  <p class="fs-text text-center lyd-title-colo1 framework_content_title" data-aos="fade-up">
                    技术中台通过自主研发的底层技术架构而搭建，中台之上，创建了包含全场景技术应用组件，通过标准组件和自定义组件，开发者及用户可以乐高式、插件式的方式，快速搭建并迭代出有价值的场景应用
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="fs-1 text-center" style="color: #005BAB;">业务中台</div>
                <div class="framework_content">
                  <img src="@/assets/images/platform/technologybg1.png" alt="">
                  <p class="fs-text text-center lyd-title-colo1 framework_content_title1" data-aos="fade-up">
                    业务中台提供针对各种业务和财务数据对象的建模能力，满足各种场景下的明细台账、汇总分析、权限控制、审批流程等需求。更适用于财务场景的核心模块，即从财务数据模型中读取数据的同时，实时进行多维汇总计算。ECOP是一个低代码平台，简单配置标准组件即可生成满足用户多样化需要的成熟模型，同时还支持用户上传使用自定义组件。平台具备强大的可扩展性和灵活性，场景化应用能够快速成熟交付
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="fs-1 text-center" style="color: #005BAB;">数据中台</div>
                <div class="framework_content">
                  <img src="@/assets/images/platform/technologybg2.png" alt="">
                  <p class="fs-text text-center lyd-title-colo1 framework_content_title" data-aos="fade-up">
                    数据中台汇聚企业级数据资产，专注打造企业数字化、智能化数据服务中台，支撑企业智慧经营能力体系建设，从数据集成、建模、到应用端到端将数据赋能于企业决策运营，围绕平台化、资产化、服务化。覆盖全链路的数据采集、分析、挖掘、任务运维、数据的质量、地图、模型、API开放等场景，充分满足企业建设数据中台过程中的多样复杂需求。兼容市面主流大数据平台，或基于数栈自有计算引擎，快速完成大数据平台从0到1的搭建
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="fs-1 text-center" style="color: #005BAB;">连接中台(连接器)</div>
                <div class="framework_content">
                  <img src="@/assets/images/platform/connectbg.png" alt="">
                  <p class="fs-text text-center lyd-title-colo1 framework_content_title2" data-aos="fade-up">
                    通过统一数据连接器与其他业务系统如生产制造系统、供应链系统等（Oracle、NC、SAP等）无缝整合，实现连接+报账实现业财的全面融合。连接中台支撑200+系统识别、500+业务类别，满足企业价值链和上下有全面协同管理，提升企业高质量发展
                  </p>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination3" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="values" id="values">
        <div class="tab-block pt-lyd-120 container ind" data-aos="fade-up">
          <h3 class="fs-1 fw-bold text-center lyd-title-colo1">平台价值</h3>
          <p class="fs-3 text-center lyd-title-colo1">云架构、低代码、微服务</p>
        </div>
        <div class="valuesBoxs container">
          <div class="valuesBoxsbg_img">
            <img class="valuesBoxs_img" src="@/assets/images/platform/value.png" alt="">
          </div>
          <div class="value" v-if="windowWidth > 767">
            <div class="valueBoxes">
              <swiper class="mySwipe swiper-no-swiping" :options="swiperOption" ref="Swipers">
                <swiper-slide v-for="(item,index) in valueData" :key="index">
                  <div class="valueBox">
                    <div class="valueBoxContent">
                      <h4 class="text-white">{{ item.title }}</h4>
                      <p class="text-white">{{ item.content }}</p>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div id="swiper-pagination">
                <div :id="Number(index)+1" class="swiperBox" v-for="(item,index) in valueData" :key="index">
                  <span :id="(Number(index)+1)+'1'" class="swiperBox_line"></span>
                  <span :id="(Number(index)+1)+'2'" class="swiperBox_content">{{"0"+(Number(index)+1)}}</span>
                </div>
              </div>
              <!-- <div class="swiper-pagination4" slot="pagination"></div> -->
            </div>
          </div>
          <div class="valuer" v-else>
            <div class="valueBoxes">
              <swiper class="mySwipe" :options="swiperOptions" ref="videoSwiper">
                <swiper-slide v-for="(item,index) in valueData" :key="index">
                  <div class="valueBox">
                    <div class="valueBoxContent">
                      <h4 class="text-white fs-1">{{ item.title }}</h4>
                      <p class="text-white">{{ item.content }}</p>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <!-- <div class="swiper-pagination1" slot="pagination"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="advantage" id="advantage">
        <div class="advatageImg">
          <img src="@/assets/images/platform/advantagebg1.png" alt="">
          <img src="@/assets/images/platform/advantagebg2.jpg" alt="">
          <img src="@/assets/images/platform/advantagebg3-new.jpg" alt="">
        </div>
        <div class="advantageBoxs container" v-if="windowWidth > 767">
          <h3 class="advantageBoxs_title fs-1 text-center text-white">平台优势</h3>
          <div class="advantageBox" v-for="(item, index) in advantageData" :key='index'>
            <img :src="item.url" alt="">
            <h4 class="text-light" v-if="titles == index" data-aos="fade-up">{{ item.title }}</h4>
            <div class="advantageBox_content text-light" v-if="titles == index" data-aos="fade-up">{{ item.content }}</div>
          </div>
          <div class="advantage_btnBox">
            <div class="advantage_btn" :class="{ 'advantage_btn_active': titles == 0 }">
              <div class="advantage_btn_content text-light" @click='changeadvatage(0)'>云原生、微服务</div>
            </div>
            <div class="advantage_btn" :class="{ 'advantage_btn_active': titles == 1 }">
              <span class="advantage_btn_content text-light" @click='changeadvatage(1)'>强大的业务能力和平台能力</span>
            </div>
            <div class="advantage_btn" :class="{ 'advantage_btn_active': titles == 2 }">
              <span class="advantage_btn_content text-light" @click='changeadvatage(2)'>Business Connector
                实现业财融合新模式</span>
            </div>
          </div>
        </div>
        <div class="valuer" v-else>
          <div class="tab-block pt-lyd-120 container ind" data-aos="fade-up">
            <h3 class="fs-1 fw-bold text-center lyd-title-colo1">平台优势</h3>
            <p class="fs-3 text-center lyd-title-colo1">云架构、低代码、微服务</p>
          </div>
          <div class="valueBoxes">
            <swiper class="mySwipe" :options="swiperOptione" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in advantageData" :key='index'>
                <div class="advantageBox">
                  <div class="advatageImg">
                    <img :class="{activer: index == 0}" src="@/assets/images/platform/advantagebg1.png" alt="">
                    <img :class="{activer: index == 1}" src="@/assets/images/platform/advantagebg2.jpg" alt="">
                    <img :class="{activer: index == 2}" src="@/assets/images/platform/advantagebg3-new.jpg" alt="">
                  </div>
                  <div class="advantageBox_box">
                    <img :src="item.url" class="ind" alt="">
                    <h4 class="text-light fs-1 ind" data-aos="fade-up">{{ item.title }}</h4>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination2" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="qualifications" id="qualifications">
        <div class="tab-block pt-lyd-120 container ind" data-aos="fade-up">
          <div class="fs-1 fw-bold text-center lyd-title-colo1">平台资质</div>
          <div class="fs-3 text-center lyd-title-colo1">云架构、低代码、微服务</div>
        </div>
        <platformSwiper class="container"></platformSwiper>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../components/common/Layout"
import platformSwiper from "@/components/common/honorSwipe/platformSwiper.vue"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'platform',
  components: { Layout, StaticBanner, swiper, swiperSlide, platformSwiper, },
  mounted() {
    console.log('页面实时宽度', this.windowWidth);
    console.log(this.Swiper);
    if (this.windowWidth > 767) {
      this.changeadvatage(0)
    }
    if (sessionStorage.getItem('a-id')) {
      this.val = sessionStorage.getItem('a-id')
      this.a_Href()
      sessionStorage.clear('a-id')
    }
  },
  data() {
    return {
      bannerDate: {
        url: require("@/assets/images/platform/platformbg.png"),
        title: "智慧创新平台ECOP",
        content: "云架构、低代码、微服务",
        btn: false,
        btns: true,
      },
      windowWidth: document.documentElement.clientWidth,
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: false,
        noSwiping: true,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination4",
        },
        on: {
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle()
          },
        },
        observer: true,
        observeParents: true,
      },
      swiperOptione: {
        speed: 1100,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperOptiones: {
        speed: 1200,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination3",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperOptions: {
        speed: 1400,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        // pagination: {
        //   el: ".swiper-pagination1",
        //   clickable: true,
        // },
        observer: true,
        observeParents: true,
      },
      imgs: [
        require("@/assets/images/platform/advantagebg1.png"),
        require("@/assets/images/platform/advantagebg2.jpg"),
        require("@/assets/images/platform/advantagebg3-new.jpg"),
      ],
      advantageData: [
        {
          "url": require("@/assets/images/platform/advantagelogo1.png"),
          "title": "云原生、微服务",
          "content": "各类的功能按照微服务的方式拆分，独立提供服务，各服务都提供集群的方式，避免单点故障；服务在安全方面，主要提供安全日志，分层权限，数据加密等方式避免系统出现安全风险，底层运行环境支持微软Azure Stack的服务器或者专属服务器"
        },
        {
          "url": require("@/assets/images/platform/advantagelogo2.png"),
          "title": "强大的业务能力和平台能力",
          "content": "可依据不同的数据分类和特性，采用不同的数据存储和管理模式的组合，尽可能的达到性能和空间的最优配置，提供元数据的管理和定义功能， 更好的管理和使用数据，使得数据的应用范围更加广泛，提供标准的数据接入服务和数据访问服务，更好的集成不同的业务系统和分析系统，更快的创造系统应用价值"
        },
        {
          "url": require("@/assets/images/platform/advantagelogo3.png"),
          "title": "Business Connector 实现业财融合新模式",
          "content": "通过连接器将来源于业务系统等信息无缝与管理中台整合。让业财融合通过智能报账实现分切面，统一数据连接器充分结合，让连接+报账实现业财的全面融合"
        }
      ],
      frameworkData: [
        {
          "title": "技术中台",
          "test": "技术中台通过自主研发的底层技术架构而搭建，中台之上，创建了包含全场景技术应用组件，通过标准组件和自定义组件，开发者及用户可以乐高式、插件式的方式，快速搭建并迭代出有价值的场景应用",
          "img": require('@/assets/images/platform/technologybg.png')
        },
        {
          "title": "业务中台",
          "test": "业务中台提供针对各种业务和财务数据对象的建模能力，满足各种场景下的明细台账、汇总分析、权限控制、审批流程等需求。更适用于财务场景的核心模块，即从财务数据模型中读取数据的同时，实时进行多维汇总计算。ECOP是一个低代码平台，简单配置标准组件即可生成满足用户多样化需要的成熟模型，同时还支持用户上传使用自定义组件。平台具备强大的可扩展性和灵活性，场景化应用能够快速成熟交付",
          "img": require('@/assets/images/platform/technologybg1.png')
        },
        {
          "title": "数据中台",
          "test": "数据中台汇聚企业级数据资产，专注打造企业数字化、智能化数据服务中台，支撑企业智慧经营能力体系建设，从数 据集成、建模、到应用端到端将数据赋能于企业决策运营，围绕平台化、资产化、服务化，聚焦数智场景，赋能行业生态，让数据产生价值。 覆盖全链路的数据采集、数据分析、数据挖掘、任务运维、数据质量、数据地图、数据模型、数据 API 开放等场景， 充分满足企业建设数据中台过程中的多样复杂需求。兼容市面主流大数据平台，或者基于数栈自有计算引擎，可以快速完成大数据平台从 0 到 1 的搭建",
          "img": require('@/assets/images/platform/technologybg2.png')
        },
        {
          "title": "连接中台(连接器)",
          "test": "通过统一数据连接器与其他业务系统如生产制造系统、供应链系统等（Oracle、NC、SAP等）无缝整合，实现连接+报账实现业财的全面融合。连接中台支撑200+系统识别、500+业务类别，满足企业价值链和上下有全面协同管理，提升企业高质量发展。",
          "img": require('@/assets/images/platform/connectbg.png')
        },
      ],
      frameworkDatas: [
      ],
      valueData: [
        {
          "title": "迭代升级，快速响应",
          "content": "平台覆盖业务应用、流程构建、数据服务、智能决策等数字化管理要素，帮助企业敏捷构建业务应用服务并不断迭代升级，从而快速响应不断变化的市场环节与客户需求"
        },
        {
          "title": "聚合服务，平台衍生",
          "content": "提供统一基座，统一服务，统一组件，所有服务聚合到统一平台中衍生，不断促进业务的标准化、规范化和统一化"
        },
        {
          "title": "规模化创新，提高业务敏捷度",
          "content": "弱化技术门槛，降低需求传递失真，提供快速编排、组合服务能力，更好地支持企业规模化创新，提高业务的敏捷，降低试错成本"
        },
        {
          "title": "共享服务，快速复用",
          "content": "通过业务抽象，将通用能力、核心能力，提炼为基础服务并下沉，提供共享服务，为前台不断变化的业务提供支撑，避免重复造轮子，实现服务快速复用"
        },
        {
          "title": "数据互通，支持业务决策和优化",
          "content": "平台各应用数据天然互通，构建企业数据资产，解决数据不一致问题，不断发挥数据价值，进而支持业务的决策和优化"
        }
      ],
      types: 1,
      titles: 0,
      val:'',
    }
  },
  computed: {
    // 获取swiper对象
    Swiper() {
      return this.$refs.Swipers
    },
  },
  methods: {
    a_Href(){
      if (this.val == 'title') {
        document.querySelector("#title").scrollIntoView(true);
      }
      if (this.val == 'values') {
        document.querySelector("#values").scrollIntoView(true);
      }
      if (this.val == 'advantage') {
        document.querySelector("#advantage").scrollIntoView(true);
      }
      if (this.val == 'qualifications') {
        document.querySelector("#qualifications").scrollIntoView(true);
      }
    },
    change(type) {
      this.types = type
    },
    colour(type) {
      document.getElementById(type).setAttribute('class', 'abc')
    },
    changeadvatage(type) {
      this.titles = type
      this.imgs.map((val,index) => {
        console.log(val,index,type);
        if(index == type){
          document.getElementById('advantage').style.backgroundImage = "url("+val+")"
          return false
        }
      })
      console.log(document.getElementById('advantage').style.backgroundImage)
    },
    slideChangeTransitionStartHandle() {
      let swiper = this.$refs.Swipers.swiper ? this.$refs.Swipers.swiper.realIndex : 0
      for (let i = 1; i < 6; i++) {
        let ids1 = i + '1'
        let ids2 = i + '2'
        if (document.getElementById(ids1).getAttribute('class').indexOf('line') != -1) {
          document.getElementById(ids1).classList.remove('line')
        }
        if (document.getElementById(ids1).getAttribute('class').indexOf('content') != -1) {
          document.getElementById(ids2).remove('content')
        }
      }
      for (let i = 1; i < Number(swiper) + 2; i++) {
        let ids1 = i + '1'
        let ids2 = i + '2'
        document.getElementById(ids1).classList.add("line");
        document.getElementById(ids2).classList.add("content");
      }
    },
    changeSwiper() {
      console.log(123123)
    }
  }
}
</script>
<style lang="scss" scoped>
.platform {
  .backimg {
    margin: 0 auto;
    max-width: 1920px;
    width: 100%;

    .backimgBox {
      margin-top: 8rem;
    }
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;

    .title_div {
      padding: 0 17rem;
      margin-bottom: 5rem;
    }
  }

  .ability {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .abilityBoxs {
      display: flex;
      justify-content: center;
      align-items: center;

      .abilityBox {
        position: relative;
        overflow: hidden;

        &:hover {
          .abilityBox_img {
            transform: scale(1.1)
          }
        }

        .abilityBox_img {
          transition: all 1s ease;
        }

        .abilityBox_content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          display: flex;
          flex-direction: column;
          align-items: center;

          div {
            text-align: center;
          }
        }
      }
    }
  }

  .framework {
    .framework_btns {
      display: flex;
      justify-content: center;

      .framework_btn {
        margin-right: 5rem;
        border: 1px solid #E1E4EB;
        border-radius: 10px;
        padding: 5px 20px;
        color: #131D35;
        cursor: pointer;
      }

      .active {
        background: #005BAB;
        color: white;
      }
    }

    .framework_contents {
      .framework_content {
        .framework_content_title {
          padding: 5rem 17rem;
        }
        .framework_title{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;
          div{
            flex: 1;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            color: #005BAB;
          }
        }
      }
    }
  }

  .values {
    margin-bottom: 7rem;

    .valuesBoxs {
      display: flex;
      background: url('../assets/images/platform/valuebg.png');
      .valuesBoxsbg_img {
        margin-left: -6px;
        overflow: hidden;
        &:hover {
          .valuesBoxs_img {
            transform: scale(1.1);
          }
        }

        .valuesBoxs_img {
          transition: all 1s ease;
        }
      }

      .value {
        width: 60rem;
        cursor: pointer;
        .valueBoxes {
          height: 100%;
          position: relative;

          .mySwipe {
            .swiper-wrapper {
              position: relative;
              .swiper-slide {
                .valueBox {
                  position: relative;
                  width: 100%;
                  height: 100%;
                  padding: 2rem;
                  .valueBoxContent {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }
          }

          #swiper-pagination {
            position: absolute;
            bottom: 2rem;
            width: 100%;
            display: flex;
            justify-content: space-around;
            padding: 0 5rem;

            .swiperBox {
              display: flex;
              flex-direction: column;
              width: 100%;

              .swiperBox_line {
                border-bottom: 1px solid #184F96;
                height: 1px;
              }

              .swiperBox_content {
                font-style: oblique;
              }

              .line {
                border-bottom: 1px solid #fff;
              }

              .content {
                color: #fff;
                font-style: oblique;
              }
            }
          }
        }
      }
      .valuer{
        height: 30rem;
        width: 35rem;
        .valueBoxes{
          overflow: hidden;
        }
      }
    }
  }

  .advantage {
    // background-image: url('../assets/images/platform/advantagebg1.png');
    height: 70rem;
    position: relative;
    .advatageImg{
      position: absolute;
      top: 0;
      left: 0;
      img{
        opacity: 0;
      }
    }
    .advantageBoxs {
      height: 100%;
      padding: 5rem 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      .advantageBox {
        height: 23rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: absolute;
        bottom: 17rem;
        img {
          width: 9%;
        }

        h4 {
          margin: 0;
        }

        .advantageBox_content {
          width: 55rem;
        }
      }

      .advantage_btnBox {
        height: 10rem;
        display: flex;
        justify-content: space-between;
        width: 60rem;
        align-items: center;

        .advantage_btn {
          width: 19rem;
          position: relative;
          background: url('../assets/images/platform/advantagebtn1.png');
          background-size: 19rem 10rem;
          height: 10rem;
          display: flex;
          align-items: center;
          cursor: pointer;

          .advantage_btn_content {
            width: 19rem;
            padding: 0 1.3rem;
            text-align: center;
          }
        }

        .advantage_btn_active {
          background: url('../assets/images/platform/advantagebtn2.png');
          background-color: #000;
          background-size: 19rem 10rem;
        }
      }
    }
  }
  #advantage{
    .valuer{
      .valueBoxes{
        .mySwipe{
          .swiper-wrapper{
            .swiper-slide{
              position: relative;
              .advatageImg{
                width: 100%;
                height: 100%;
                img{
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 980%;
                  height: 98%;
                }
                .activer{
                  opacity: 1;
                }
              }
              .advantageBox{
                .advantageBox_box{
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  justify-content: space-between;
                  margin-bottom: 1rem;
                }
              }
            }
          }
        }
      }
    }
  }
  .qualifications{
    padding: 1rem;
  }
}
</style>